import React from 'react';
import PropTypes from 'prop-types';
import * as Badges from './Badges';
import { BadgeController } from './BadgesController';
import { clickEvents } from '../../../utils/analytics';

export const BadgeRenderer = ({ profileData, badgeSize }) => {
  let badgeController = new BadgeController();
  let sortedBadgeArray = badgeController.badgesByWeight;
  let hasBadges = badgeController.profileHasBadges(profileData);

  const badgeTooltipAnalytics = (badgeType) => {
    return () => clickEvents.candidateBadgeProfileInteraction(badgeType, profileData.candidateId);
  };

  if (!hasBadges) {
    return (<></>);
  }

  return (
    <div className="ptp-search-grid-item__badge">
      {sortedBadgeArray.map((badge) => {
        if (!badge.shouldRender(profileData)) {
          return null;
        }
        // get the badge from the name out of the badges module
        const Badge = Badges[badge.name];

        return (
          <Badge onShowTooltip={badgeTooltipAnalytics(badge.analyticsName)} key={badge.name} size={badgeSize} />
        );
      })}
    </div>
  );
};

BadgeRenderer.propTypes = {
  profileData: PropTypes.shape({
    accreditations: PropTypes.arrayOf(PropTypes.string),
    education: PropTypes.string,
    militaryStatus: PropTypes.string,
    candidateId: PropTypes.string
  }).isRequired,
  badgeSize: PropTypes.string
};

BadgeRenderer.defaultProps = {
  badgeSize: ''
};
